import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { AggregationFunction } from "@multiweb/clients/dataReader";
import { createGetLocalizedOptions, getPrimaryText, getSecondaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { createAggregationFunctionSelectedAction } from "../../actions";
import { SELECT_OPTION_LOC_KEY } from "../../locKeys";
import { AGGREGATION_OPTIONS } from "../../options";
import { getColumnAggregationFunction } from "../../selectors";
import { AggregationRowKey, ColumnKey } from "../../types";
import { AggregationSelectComponent, AggregationSelectComponentProps } from "../AggregationSelectComponent";

export type AggregationSelectProps = {
    /** Klíč agregačního řádku */
    aggregationRowKey: AggregationRowKey;
    /** Klíč sloupce */
    columnKey: ColumnKey;
};

type StateProps = Pick<AggregationSelectComponentProps, "value" | "defaultText" | "title" | "options">;

const createMapStateToProps: () => MapStateToProps<StateProps, AggregationSelectProps, IAppState> = () => {
    const getLocalizedOptions = createGetLocalizedOptions<AggregationFunction>(AGGREGATION_OPTIONS);

    return (state, { aggregationRowKey, columnKey }) => ({
        value: getColumnAggregationFunction(state, { aggregationRowKey, columnKey }),
        options: getLocalizedOptions(state),
        defaultText: getPrimaryText(state, SELECT_OPTION_LOC_KEY),
        title: getSecondaryText(state, SELECT_OPTION_LOC_KEY),
    });
};

type DispatchProps = Pick<AggregationSelectComponentProps, "onChange">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, AggregationSelectProps> = (dispatch, { aggregationRowKey, columnKey }) => ({
    onChange: (aggregationFunction) => dispatch(createAggregationFunctionSelectedAction(aggregationRowKey, columnKey, aggregationFunction)),
});

export const AggregationSelect = connect(createMapStateToProps, mapDispatchToProps)(AggregationSelectComponent);
